import { Tv, Smartphone, Tablet, MonitorSmartphone, Cast } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const DEVICES = [
  { icon: Tv, name: "Smart TV" },
  { icon: Smartphone, name: "Android" },
  { icon: Tablet, name: "iPhone / iPad" },
  { icon: MonitorSmartphone, name: "Android TV" },
  { icon: Cast, name: "Streaming Devices" },
];

export default function Devices() {
  return (
    <section id="devices" className="section-fade py-16 md:py-28" data-testid="devices-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="Device compatibility"
          title="Stream on the devices you already own"
          sub="IPTV HUB is designed to work beautifully across the screens in your home."
        />
        <div className="grid gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {DEVICES.map((d, i) => (
            <Reveal key={d.name} delay={i * 0.07} className="h-full">
              <div
                data-testid={`device-card-${d.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="glass glass-hover group flex h-full flex-col items-center rounded-2xl px-6 py-10 text-center"
              >
                <div className="mb-5 inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-electric/25 bg-electric/10 text-electric shadow-[0_0_20px_rgba(0,240,255,0.15)] transition-transform duration-300 group-hover:scale-110">
                  <d.icon className="h-7 w-7" />
                </div>
                <h3 className="font-display text-sm font-semibold text-slate-900">{d.name}</h3>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <p className="mt-10 text-center text-sm text-slate-500">
            And most popular supported streaming devices — <a href="#contact" data-testid="devices-contact-link" onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }} className="text-electric hover:underline">contact us</a> to confirm yours.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
